import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { INationality } from "../../utils/types/models";

export default createEntityReducer<INationality>(Endpoint.Nationalities, Endpoint.NationalitiesList);
